














import {Component, Mixins, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component
export default class GasbotCommandsCard extends Mixins(MixinScreenSize) {
  @Prop({type: String, required: true}) command!: string
  @Prop({type: String, required: true}) description!: string

  formatCommand(command: string): string {
    return `/${command}`
  }
}
